<template>
  <div id="app">
    <app-date-calculation></app-date-calculation>
  </div>
</template>

<script>
import DateCalculation from "./components/DateCalculation.vue";

export default {
  components: {
    appDateCalculation: DateCalculation
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
